module.exports = require("object.fromentries");